import { Button, Drawer } from 'antd';
import './index.less'
import { CloseOutlined } from '@ant-design/icons';
export const FullScreenModal = ({url,open,setOpen}: {url: string,open: boolean,setOpen: React.Dispatch<React.SetStateAction<boolean>>}) => {
    return <Drawer
    title=""
    destroyOnClose={true}
    onClose={() => setOpen(false)}
    placement={'top'}
    height={'100%'}
    open={open}
    className='full-screen-modal-wrapper'
  >
    <video className='modal-video' webkit-playsinline="true" playsInline autoPlay controls={true} src={url}></video>
  </Drawer>
}
export const FullScreenModal2 = ({url,open,setOpen}: {url: string,open: boolean,setOpen: React.Dispatch<React.SetStateAction<boolean>>}) => {
  return <Drawer
  title=""
  destroyOnClose={true}
  onClose={() => setOpen(false)}
  placement={'top'}
  height={'100%'}
  open={open}
  className='full-screen-modal-wrapper'
>
<div style={{position: 'relative',width: '100%',height: '100%'}} >
    {/* <iframe src={url} scrolling="no"   style={{position: 'absolute', width: '100%', height: '100%', left: 0, top: 0,border:0}}></iframe> */}
    <iframe src={url} title="Snailcle"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" style={{position: 'absolute', width: '100%', height: '100%', left: 0, top: 0,border:0}}></iframe>
</div>
</Drawer>
}